import { z } from "zod";
import { COLORS } from "../../colors";

/** A cost centre as the settings form writes it. The number is unique within the organisation. */
export const costCenterSchema = z.object({
	number: z.string().trim().min(1).max(30),
	name: z.string().trim().min(1).max(100),
	color: z.enum(COLORS),
	isActive: z.boolean(),
});

export type CostCenterSchema = z.infer<typeof costCenterSchema>;
